import { render, staticRenderFns } from "./HomeGame.vue?vue&type=template&id=a5052798&scoped=true"
import script from "./HomeGame.vue?vue&type=script&lang=js"
export * from "./HomeGame.vue?vue&type=script&lang=js"
import style0 from "./HomeGame.vue?vue&type=style&index=0&id=a5052798&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5052798",
  null
  
)

export default component.exports